import { useTranslation } from 'next-i18next';
import React from 'react';
import { useDispatch } from 'react-redux';
import { SpeakerEntry, SpeakersComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { setSpeakerModal } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../../pageBuilder/TitleAndDescription';
import SpeakerComponent from './Speaker';

const SpeakersUiComponent = ({ uiComponent }: UiComponentElementInterface<SpeakersComponentInterface>) => {
  if (!uiComponent) return null;
  const eventSpeakers = useSelector((state) => state.common.eventSpeakers);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  function openSpeaker(s: SpeakerEntry) {
    dispatch(
      setSpeakerModal({
        speaker: s,
        textColor: uiComponent?.customStyling.modalTextColor,
        showPosition: uiComponent?.customStyling.showPositions,
      })
    );
  }

  let speakersToDisplay = uiComponent.entryIds.filter((speaker) => eventSpeakers?.map((s) => s._id).includes(speaker._id));

  if (uiComponent.sortBy === 'ALPHABETIC') {
    speakersToDisplay = speakersToDisplay.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  return (
    <>
      <TitleAndDescription component={uiComponent} />
      <div
        className={`w-full`}
        style={{
          color: uiComponent?.styling?.textColor || '#000',
        }}>
        {speakersToDisplay?.length === 0 && <EmptyComponent componentName={t('pagebuilder:speakers')} />}
        {speakersToDisplay?.length !== 0 && (
          <div
            className="speakers-list w-full grid justify-center @md:justify-between"
            style={{
              gridTemplateColumns: 'repeat(auto-fill, 13rem)',
              gridAutoRows: '1fr',
              gap: '2rem',
            }}>
            {speakersToDisplay?.map((speaker, index) => (
              <SpeakerComponent
                key={`${speaker.name}-${index}`}
                speaker={speaker}
                onSelect={() => openSpeaker(speaker)}
                showPosition={uiComponent?.customStyling?.showPositions}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SpeakersUiComponent;
